module.exports = __webpack_public_path__ + "img/patient-profile-fu-1536x760.cc2b40b6.png";